import { useEffect, useState, useMemo } from "react";
import Loading from "../Loading";
import getAssetPath from "src/Utils/getAssetPath";
import setCurrentPage from "src/Utils/setCurrentPage";

interface PreloadProps {
  children: React.ReactNode;
}

const Preload = ({ children }: PreloadProps) => {
  const [loading, setLoading] = useState(true);
  const [loadedItems, setLoadedItems] = useState(0);
  const [parameterChecked, setParameterChecked] = useState(false);

  const assets = useMemo(() => [getAssetPath("/images/BG/BG_1.jpg")], []);

  useEffect(() => {
    const handleLoad = () => {
      setLoadedItems((prev) => prev + 1);
    };

    const preloadAssets = () => {
      assets.forEach((asset) => {
        if (asset.endsWith(".mp4")) {
          const video = document.createElement("video");
          video.src = asset;
          video.preload = "auto";
          video.onloadeddata = handleLoad;
        } else {
          const img = new Image();
          img.src = asset;
          img.onload = handleLoad;
        }
      });
    };

    preloadAssets();
  }, [assets]);

  useEffect(() => {
    const getQueryParam = (param: string) => {
      const params = new URLSearchParams(window.location.search);
      return params.get(param);
    };

    try {
      const page = getQueryParam("page");
      console.log("page", page);
      console.log("page", Number(page) === 2);
      if (Number(page) === 2) setCurrentPage(2);
    } catch (error) {
    } finally {
      setTimeout(() => {
        console.log("parameterChecked");
        setParameterChecked(true);
      }, 10);
    }
  }, []);

  useEffect(() => {
    if (loadedItems === assets.length && parameterChecked) setLoading(false);
  }, [loadedItems, assets, parameterChecked]);

  return <>{loading ? <Loading /> : <>{children}</>}</>;
};

export default Preload;
